import {ServiceTypeEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {ObjectMappingDataTableCard} from "../../card/ObjectMappingDataTableCard/ObjectMappingDataTableCard";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {DefaultText} from "@ots-frontend/ots-ui";

export type ServiceTypeDetailsProps = {
  serviceType: ServiceTypeEntity
}

export const ServiceTypeDetails = (props: ServiceTypeDetailsProps) => {
  const {serviceType} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={12}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.servicetype.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.servicetype.info.field.name.label", "Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {serviceType.name}
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.servicetype.info.field.abbr.label", "Abbreviation")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={serviceType.abbr} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.servicetype.info.field.desc.label", "Description")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={serviceType.description} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.servicetype.info.field.usable.label", "Usable")}
              </Text>
              <Text ta="left" c={serviceType.doNotUse ? "warning" : "dimmed"} fz="xs">
                {serviceType.doNotUse ? t("common.shared.no", "No") : t("common.shared.yes", "Yes")}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <Grid.Col span={12}>
        <HasAccess permissions={["object_mapping_view"]}>
          <ObjectMappingDataTableCard entity={serviceType}/>
        </HasAccess>
      </Grid.Col>
    </Grid>
  );
};

